import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SpeechRecognitionService } from '../../../../core/services/speech-recognition.service';
import { QuickPlayService } from '../../services/quick-play.service';
import { VoiceSpeechDialogComponent, VoiceDialogData } from './voice-speech-dialog.component';

// Import global speech recognition types
declare var SpeechRecognition: any;
declare var webkitSpeechRecognition: any;

interface SpeechRecognition extends EventTarget {
  continuous: boolean;
  interimResults: boolean;
  lang: string;
  maxAlternatives: number;
  onstart: () => void;
  onresult: (event: SpeechRecognitionEvent) => void;
  onerror: (event: SpeechRecognitionErrorEvent) => void;
  onend: () => void;
  start(): void;
  stop(): void;
}

interface SpeechRecognitionEvent extends Event {
  results: SpeechRecognitionResultList;
  resultIndex: number;
}

interface SpeechRecognitionErrorEvent extends Event {
  error: string;
  message: string;
}

interface SpeechRecognitionResultList {
  length: number;
  item(index: number): SpeechRecognitionResult;
  [index: number]: SpeechRecognitionResult;
}

interface SpeechRecognitionResult {
  length: number;
  item(index: number): SpeechRecognitionAlternative;
  [index: number]: SpeechRecognitionAlternative;
  isFinal: boolean;
}

interface SpeechRecognitionAlternative {
  transcript: string;
  confidence: number;
}

@Component({
  selector: 'app-voice-speech',
  templateUrl: './voice-speech.component.html',
  styleUrls: ['./voice-speech.component.scss']
})
export class VoiceSpeechComponent implements OnInit, OnDestroy {
  @Input() disabled = false;
  
  speechSupported = false;
  isProcessing = false;
  
  constructor(
    private dialog: MatDialog,
    private speechService: SpeechRecognitionService,
    private snackBar: MatSnackBar
  ) {}
  
  async ngOnInit() {
    this.speechSupported = this.speechService.isSupported();
  }
  
  ngOnDestroy() {
    // No cleanup needed for the button component
  }
  
  openVoiceDialog() {
    if (this.disabled || this.isProcessing) {
      return;
    }
    
    if (!this.speechSupported) {
      this.snackBar.open('Voice recognition not supported in this browser', 'Close', {
        duration: 3000
      });
      return;
    }
    
    this.isProcessing = true;
    
    const dialogRef = this.dialog.open(VoiceSpeechDialogComponent, {
      width: '600px',
      maxWidth: '90vw',
      disableClose: false,
      data: { autoStart: true } as VoiceDialogData
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      this.isProcessing = false;
      
      if (result?.success) {
        this.snackBar.open(`Successfully created playlist: "${result.command}"`, 'Close', {
          duration: 3000
        });
      }
    });
  }
  
  getButtonIcon(): string {
    if (this.isProcessing) return 'hourglass_empty';
    return 'mic';
  }
}